import React, { useState, useEffect } from "react";
import { GET_FILE_BY_ID_API_ROUTE } from "src/app/chats-panel/~api/apiRoutes";
import './CreateMailingInfoPreview.css';
import { ICreateMailingInfoPreviewProps } from "./~types/CreateMailingInfoPreviewProps";

const CreateMailingInfoPreview = (props: ICreateMailingInfoPreviewProps) => {
    const [previewSrc, setPreviewSrc] = useState<string | undefined>();

    useEffect(() => {
        if (props.image) {
            const objectUrl = URL.createObjectURL(props.image);
            setPreviewSrc(objectUrl);
            return () => URL.revokeObjectURL(objectUrl);
        } else {
            setPreviewSrc(undefined);
        }
    }, [props.image]); 

    return (
        <span className="mailing-item-info__create-mailing-preview">
            {previewSrc && (
                <img
                    className="mailing-item-info__image-block-input-field-image"
                    src={previewSrc}
                />)}
            {(props.text !== '' || props.buttonText !== '') &&
                <div className="mailing-item-info__create-mailing-preview__text-message">
                    {props.text !== '' &&
                        <div className="mailing-item-info__create-mailing-preview__text-message__text">
                            {props.text}
                        </div>}
                    {props.buttonText !== '' &&
                        <div className="mailing-item-info__create-mailing-preview__text-message__button btn btn-secondary">
                            {props.buttonText}
                        </div>}
                </div>}
        </span>
    );
};

export default CreateMailingInfoPreview;